export const studioHighlights = [
  {
    id: "01",
    title: "Regional Impact",
    description:
      "We bring clarity, depth, and balance to your sound. From recording to mixing and mastering, our expert audio engineering ensures your project is delivered with professional quality and precision.",
  },
  {
    id: "02",
    title: "Creative Projects",
    description:
      "We elevate your brand, services, and storytelling through thoughtful, high-impact design—combining creativity with precision to ensure every detail aligns with your vision.",
  },
  {
    id: "03",
    title: "Community Reach",
    description:
      "We craft intuitive digital experiences through thoughtful UX/UI design and agile development. Whether building from scratch or refining what exists, we align form and function to meet your audience’s needs and your goals.",
  },
  {
    id: "04",
    title: "Legacy & Innovation",
    description:
      "We’re with you every step of the way. From first concept to final delivery, our team offers responsive, reliable support tailored to your project’s unique needs—because your success is our priority.",
  },
];


export const studioStats = [
    {
        id: "1",
        amount: "12+",
        description: "Years of Experience",
    },
    {
        id: "2",
        amount: "1K+",
        description: "Satisfied Clients",
    },
    {
        id: "3",
        amount: "2K+",
        description: "Projects Done",
    },
    {
        id: "4",
        amount: "4K+",
        description: "Cups of Coffee",
    },
];
